import { useStaticQuery, graphql } from "gatsby";
import SummarySection from "../../components/Sections/SummarySection";

const ReferSummaryBlock = () => {
  const data = useStaticQuery(graphql`
    query ReferSummaryBlockQuery {
      allDataJson {
        edges {
          node {
            Refer {
              ReferSummaryBlock {
                heading {
                  text
                  color
                }
                subText {
                  text
                  color
                }
                button1 {
                  to
                  text
                  variant
                }
              }
            }
          }
        }
      }
    }
  `);
  const { ReferSummaryBlock } = data.allDataJson.edges[0].node.Refer;

  return <SummarySection {...ReferSummaryBlock} />;
};

export default ReferSummaryBlock;
